module.exports = __webpack_public_path__ + "media/logos/lexshares-small-15248668.png";